import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'truncate',
})
export class TruncateStringPipe implements PipeTransform {
	transform(value: string, args: any[]): string {
		const limit = args.length > 0 ? parseInt(args[0]) : 40;
		const trail = args.length > 1 ? args[1] : '...';
		return value.length > limit ? value.substr(0, limit) + trail : value;
	}
}
